module.exports = __webpack_public_path__ + "static/media/(V)_MG_6055_-_Cia_Termal_Beachewear_-_Moda_Bebe.b87dc245.jpg";